<template>
  <div class="customer-select">
    <div v-if="disabled" class="disabled-box"></div>
    <div
      class="customer-select__drawer"
      :class="{ 'is-show-clear': isShowClear && modelValue.id !== '0' }"
      @click="handleClick"
    >
      <div v-if="modelValue?.id" class="customer-select__name text-overflow">
        {{ modelValue.name }}
      </div>
      <div v-else class="customer-select__placeholder">请选择客户</div>
      <i class="icon-arrow-down-s-line t-iconfont" />
      <i v-if="isShowClear" class="icon-close-circle-line t-iconfont" @click.stop="handleClear" />
    </div>
    <el-drawer v-model="drawer" direction="btt" :show-close="false" size="80%" :with-header="false">
      <div class="drawer-content">
        <div class="head">
          <div class="left" @click="drawer = false">
            <i class="icon-close-line t-iconfont" />
          </div>
          <div class="center">客户</div>
          <div class="right" @click="handlAddcustomer">新建</div>
        </div>
        <div class="content">
          <el-input
            v-model="searchValue"
            clearable
            placeholder="搜索客户"
            :prefix-icon="Search"
            style="padding: 12px; border-bottom: 1px solid #f2f3f5"
            @input="getList"
          />

          <template v-if="!searchValue && locationSuccess">
            <div class="location-desc">附近客户推荐</div>
          </template>
          <template v-if="loading">
            <div class="location-loading">
              <svg
                fill="none"
                height="24"
                version="1.1"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <clipPath id="master_svg0_697_029612">
                    <rect height="24" rx="0" width="24" x="0" y="0" />
                  </clipPath>
                </defs>
                <g clip-path="url(#master_svg0_697_029612)">
                  <g>
                    <path
                      d="M18.364,5.6360402L16.949699000000003,7.0502501C15.683,5.783500200000001,13.933,5,12,5C8.1340103,5,5,8.1340103,5,12C5,15.866,8.1340103,19,12,19C15.866,19,19,15.866,19,12L21,12C21,16.970599999999997,16.970599999999997,21,12,21C7.0294399,21,3,16.970599999999997,3,12C3,7.0294399,7.0294399,3,12,3C14.4853,3,16.735300000000002,4.00736,18.364,5.6360402Z"
                      fill="#7a52f4"
                      fill-opacity="1"
                    />
                  </g>
                </g>
              </svg>
              <span>{{ isLocation ? '定位中，将为你推荐附近客户' : '客户加载中' }}</span>
            </div>
          </template>
          <template v-else>
            <template v-if="searchValue && customerList.length === 0">
              <div class="no-customer">
                <span>暂无客户，</span>
                <span class="create-link" @click="handlAddcustomer">去新建</span>
              </div>
            </template>
            <template v-if="customerList.length || listLoading">
              <div class="customer-select-content">
                <van-list
                  v-model:loading="listLoading"
                  :finished="page >= pageTotal"
                  finished-text="已加载全部"
                  :offset="150"
                  @load="getMore"
                >
                  <template v-for="item in customerList" :key="item.id">
                    <div class="customer-select-item" @click="handleSelectCustomer(item)">
                      <span class="text-overflow" v-html="highlightName(item.name, searchValue)">
                      </span>
                    </div>
                    <div class="bottom-line"></div>
                  </template>
                </van-list>
              </div>
            </template>
          </template>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { getCustomerList } from '@/api'
import utils from '@/utils'
import { showToast } from 'vant'
import xbb from '@xbb/xbb-utils'

const modelValue = defineModel('modelValue', { type: Object, required: true })
const searchValue = ref('')
const drawer = ref(false)
const page = ref(1)
const pageSize = ref(20)
const pageTotal = ref(0)

const dropdownRef = ref(null)

const customerList = ref([])
const loading = ref(true)
const listLoading = ref(false)

const locationLoading = ref(false)
const locationSuccess = ref(false)
const location = ref({
  latitude: '',
  longitude: ''
})

const emits = defineEmits(['addCustomer', 'change'])

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  isShowClear: {
    type: Boolean,
    default: false
  },
  addCustomerShow: {
    type: Boolean,
    default: true
  },
  isLocation: {
    type: Boolean,
    default: false
  }
  // location: {
  //   type: Object,
  //   default: () => ({
  //     latitude: '',
  //     longitude: ''
  //   })
  // }
})

/**
 * @description 客户名称高亮显示搜索关键词
 * @param name 客户名称
 * @param searchValue 搜索关键词
 */
const highlightName = (name, searchValue) => {
  if (!searchValue) {
    return name
  }
  const index = name.indexOf(searchValue)
  if (index === -1) {
    return name
  }
  return `${name.slice(0, index)}<span style="color: #7a52f4;">${searchValue}</span>${name.slice(
    index + searchValue.length
  )}`
}

/**
 * @description 选择客户
 * @param item 客户对象
 */
const handleSelectCustomer = (item) => {
  modelValue.value = item
  drawer.value = false
  emits('change', item)
}

const getList = async () => {
  loading.value = true
  page.value = 1
  pageTotal.value = 0
  customerList.value = []
  listLoading.value = false
  const filter = {
    page: page.value,
    pageSize: pageSize.value
  }
  if (searchValue.value) {
    filter.nameLike = searchValue.value
  } else if (props.isLocation) {
    filter.latitude = location.value.latitude
    filter.longitude = location.value.longitude
  }
  try {
    const res = await getCustomerList(filter)
    customerList.value = res.result.customerList
    pageTotal.value = res.result.pageHelper.pageTotal
  } catch (error) {
    console.log(error)
  }
  loading.value = false
  locationLoading.value = false
}

/**
 * @description 滚动加载更多客户（van-list @load 回调）
 */
const getMore = async () => {
  if (page.value >= pageTotal.value) {
    listLoading.value = false
    return
  }
  page.value++
  const filter = {
    page: page.value,
    pageSize: pageSize.value
  }
  if (searchValue.value) {
    filter.nameLike = searchValue.value
  } else if (props.isLocation) {
    filter.latitude = location.value.latitude
    filter.longitude = location.value.longitude
  }
  try {
    const res = await getCustomerList(filter)
    customerList.value = [...customerList.value, ...res.result.customerList]
  } catch (error) {
    console.log(error)
  }
  listLoading.value = false
}

const handleClick = () => {
  drawer.value = true
  if (props.isLocation && !location.value.latitude) {
    locationLoading.value = true
    try {
      if (xbb.isDevEnv()) {
        const position = {
          province: '浙江省',
          city: '杭州市',
          district: '滨江区',
          address: '浙江省杭州市滨江区滨盛路1505号银丰大厦',
          latitude: 30.21272,
          longitude: 120.212599
        }
        location.value.latitude = position.latitude
        location.value.longitude = position.longitude
        locationSuccess.value = true
        getList()
      } else {
        utils.xbbGetLocation({
          onSuccess: (res) => {
            const { latitude, longitude } = res
            // 定位信息需要包含经纬度
            location.value.latitude = latitude
            location.value.longitude = longitude
            locationSuccess.value = true
            getList()
          },
          onFail: (_err) => {
            if (xbb.browser() === 'ios') {
              showToast('定位失败，请重试或检查定位权限是否开启')
            } else {
              showToast('定位失败，请重试或检查精确定位权限是否开启')
            }
            locationSuccess.value = false
            getList()
          }
        })
      }
    } catch (error) {
      getList()
    } finally {
      locationLoading.value = false
      loading.value = false
    }
  } else {
    // 非定位客户，直接获取客户列表
    getList()
  }
}

function handleClear() {
  modelValue.value = {
    name: '全部客户',
    id: '0'
  }
}

const handlAddcustomer = () => {
  drawer.value = false
  emits('addCustomer')
}

// onMounted(() => {
//   if (props.location.latitude && props.location.longitude) {
//     location.value = props.location
//     getList()
//   }
// })

defineExpose({
  getList,
  dropdownRef
})
</script>

<style scoped lang="less">
.customer-select {
  flex: 1;
  position: relative;
  width: 100%;
  overflow: hidden;
  .customer-select__name {
    flex: 1;
  }
  .disabled-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(243, 246, 249, 0.6);
    z-index: 10;
    cursor: not-allowed;
  }

  :deep(.el-drawer) {
    border-radius: 20px 20px 0px 0px;
  }
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    .left {
      flex: 0 0 52px;
      text-align: left;
      font-family: PingFang SC;
      i {
        font-size: 24px;
        line-height: 24px;
        color: #969799;
      }
    }
    .right {
      flex: 0 0 52px;
      text-align: right;
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 20px;
      color: #969799;
    }
    .head {
      flex: 0 0 auto;
      overflow: hidden;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 16px;
      /* 三级文字/常规 */
      font-family: PingFang SC;
      font-size: 16px;
      line-height: 22px;

      color: #323233;
    }
    .content {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      :deep(.el-input__wrapper) {
        background: #f7f8fa;
        padding: 3px 8px;
        box-shadow: none;
        border-radius: 8px;
      }
      .location-loading {
        color: #969799;
        font-family: PingFang SC;
        font-size: 14px;
        padding: 8px 16px 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-left: 8px;
        }
        svg {
          /** 持续转圈 */
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          } /* 起始角度0度 */
          to {
            transform: rotate(360deg);
          } /* 结束角度360度 */
        }
      }
      .location-desc {
        padding: 8px 16px 8px 16px;
        font-family: PingFang SC;
        font-size: 12px;
        line-height: 16px;
        color: #969799;
        box-sizing: border-box;
      }
      .no-customer {
        margin-top: 24px;
        display: flex;
        justify-content: center;
        font-family: PingFang SC;
        font-size: 14px;
        line-height: 20px;
        color: #969799;
        .create-link {
          color: #248df5;
        }
      }
      .customer-select-content {
        flex: 1;
        padding-bottom: 48px;
        overflow-y: auto;
        .customer-select-item {
          height: 48px;
          padding: 0 28px;
          line-height: 48px;
          box-sizing: border-box;
          overflow: hidden;
          display: flex;
        }
        .bottom-line {
          height: 1px;
          background: #e5e6eb;
          transform: scaleY(0.5);
        }
        .no-more,
        .load-more {
          display: flex;
          font-size: 14px;
          line-height: 20px;
          margin-top: 12px;
          justify-content: center;
          color: #c8c9cc;
        }
      }
    }
  }

  .customer-select__drawer {
    cursor: pointer;
    flex: 1;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #e5e6eb;
    width: 100%;
    .customer-select__name {
      margin-right: 8px;
      width: 100%;
    }

    .customer-select__placeholder {
      color: #c8c9cc;
      line-height: 18px;
    }
    .customer-select__name {
      line-height: 18px;
    }

    i {
      line-height: 18px;
    }
  }
}
.icon-close-circle-line {
  display: none;
}
.is-show-clear:hover {
  .icon-close-circle-line {
    display: block;
  }
  .icon-arrow-down-s-line {
    display: none;
  }
}
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
